module.exports = __webpack_public_path__ + "img/img-2-3mobile.a3052b3a.webp";